var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertVersionnAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69783 13.3033C-0.234893 10.3706 -0.234893 5.62942 2.69783 2.6967C5.63056 -0.236027 10.3717 -0.236027 13.3044 2.6967C16.2372 5.62942 16.2372 10.3706 13.3044 13.3033C10.3717 16.236 5.63056 16.236 2.69783 13.3033ZM11.8142 8.74776C12.2279 8.74776 12.562 8.41365 12.562 7.99999C12.5567 7.59164 12.2173 7.25223 11.8142 7.25223L8.7489 7.25223V4.18692C8.7489 3.77326 8.41479 3.43916 8.00114 3.43916C7.58748 3.43916 7.25337 3.77326 7.25337 4.18692L7.25337 7.25223H4.18806C3.77441 7.25223 3.4403 7.58634 3.4403 7.99999C3.44007 8.19838 3.51879 8.38871 3.65907 8.52899C3.79935 8.66927 3.98968 8.74798 4.18806 8.74776H7.25337L7.25337 11.8131C7.25315 12.0115 7.33186 12.2018 7.47214 12.3421C7.61242 12.4823 7.80275 12.5611 8.00114 12.5608C8.41479 12.5608 8.7489 12.2267 8.7489 11.8131L8.7489 8.74776L11.8142 8.74776Z",
    fill: "#5A87EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertVersionnAdd);
export default __webpack_public_path__ + "static/media/expert-versionn-add.ec0b1197b3c8c1eedfd0c4a5006c2fa1.svg";
export { ForwardRef as ReactComponent };